import {target} from '../utils/dom';
import Keyer from './keyer';
import events from '../events';
import {matchMedia} from './breakpoints';

const closeEvent = new CustomEvent('layoutClose', {bubbles: true});
const openEvent = new CustomEvent('layoutOpen', {bubbles: true});

const body = document.getElementsByTagName('body')[0];

const keyer = new Keyer();
keyer.start();
keyer.on('esc', onEscDown.bind(this));

document.addEventListener('click', click);

events.on('openLayout', activateLayout);
events.on('closeLayout', deactivateLayout);

function click(event) {
	let tar = event.target;

	if (checkTrigger(tar)) {
		event.preventDefault();
		return;
	}

	checkLayout(tar);
}

function checkLayout(tar) {
	let layout = target(tar, '[data-layout].active');
	if (layout) {
		let id = layout.getAttribute('data-layout');
		let wrap = layout.query(`[data-layout-wrap=${id}]`);
		if (wrap && !target(tar, wrap)) {
			deactivateLayout(layout);
		} else if (!target(tar, '[data-layout] > *')) {
			deactivateLayout(layout);
		}
		return true;
	}

	deactivateAllLayout();
}

function checkTrigger(tar) {
	let trigger = target(tar, '[data-layout-trigger]');
	if (trigger) {
		let id = trigger.getAttribute('data-layout-trigger');
		let layout = document.querySelector(`[data-layout*=${id}]`);
		if (layout.classList.contains('active')) {
			deactivateLayout(layout);
		} else {
			activateLayout(layout, id);
		}
		return true;
	}
}

function activateLayout(layout, id) {
	deactivateAllLayout(layout, true);
	layout.classList.add('active');
	layout.setAttribute('data-layout-applied', id);
	layout.dispatchEvent(openEvent);
	let scroll = layout.getAttribute('data-layout-scroll');
	if (scroll === null || (scroll && !matchMedia(scroll))) {
		body.classList.add('noscroll');
	}
}

function deactivateLayout(layout, keepScroll) {
	layout.classList.remove('active');
	layout.removeAttribute('data-layout-applied');
	layout.dispatchEvent(closeEvent);
	let scroll = layout.getAttribute('data-layout-scroll');
	if (layout && (scroll === null || (scroll && !matchMedia(scroll))) && !keepScroll) {
		body.classList.remove('noscroll');
	}
}

function deactivateAllLayout(current, keepScroll) {
	const layouts = document.queryAll('[data-layout]');
	layouts.forEach((layout) => {
		if (layout.classList.contains('active') && ((current && layout !== current) || !current)) {
			deactivateLayout(layout, keepScroll);
		}
	});
}

function onEscDown() {
	let layouts = document.querySelectorAll('[data-layout].active');
	for (let layout of layouts) {
		deactivateLayout(layout);
	}
}

export default {
	deactivateLayout
};
